export default class Permission {
  setControls(path) {
    let status;
    if (localStorage.getItem("m7_dash_User_Type") != "superadmin") {
      if (localStorage.getItem("m7_dash_controls")) {
        let controls = JSON.parse(localStorage.getItem("m7_dash_controls"));
        const found = controls.find((control) => control.url == path);

        if (found) {
          status = false;
        } else {
          status = true;
        }
      }
    } else {
      status = false;
    }
    return status;
  }
  allowed(path) {
    let status;
    if (localStorage.getItem("m7_dash_User_Type") != "superadmin") {
      if (localStorage.getItem("m7_dash_permissions")) {
        let controls = JSON.parse(localStorage.getItem("m7_dash_permissions"));
        // console.log("path" + path);
        // console.log("control" + controls);
        // console.log(controls);
        const found = controls.find((control) => control?.front_name == path);
        
        if (found) {
          status = false;
        } else {
          status = true;
        }
      }
    } else {
      status = false;
    }
    return status;
  }
}
